import React from 'react';
import RedTick from '../../assets/icons/alert-icon.svg';
import GreenTick from '../../assets/icons/check-circle-green.svg';
import BlackTick from '../../assets/icons/check-circle-black.svg';
import YellowTick from '../../assets/icons/check-circle-yellow.svg';
import BlueTick from '../../assets/icons/check-circle-blue.svg';
import DefaultIcon from '../../assets/icons/defaultIcon.svg';

type AlertColor = 'success' | 'error' | 'warning' | 'info' | 'open';

export const getAlertIcon = (color: AlertColor, customIcon?: React.ReactNode): React.ReactNode => {
  if (customIcon) {
    return customIcon;
  }

  switch (color) {
    case 'success':
      return <GreenTick />;
    case 'error':
      return <RedTick />;
    case 'warning':
      return <YellowTick />;
    case 'info':
      return <BlueTick />;
    case 'open':
      return <BlackTick />;
    default:
      return <DefaultIcon />;
  }
};
